import styled, { css } from 'styled-components';
import Colors from "constants/Colors";

export const Container = styled.div`
  width: 100%;
`;

export const DeductibleContainer = styled.div`
  display: block;  
  padding: 0px 20px 0px 20px;
  min-width: 90%;
`;

export const Carrossel = styled.div`
  display: flex;
  align-items: center;
  background-color: transparent;
  width: 95%;
  height: auto;
  margin: 5px;
`;
export const ExtraText = styled.div`
  width: 100%;
  display: flex;
  flex-flow: wrap;
  text-align: end;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 10px;
`

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 90%;
  min-height: 550px;
  border-radius: 8px;
  padding: 10px;
  drag: true;
  margin-bottom: 30px;
  `;

  export const ItemHead = styled.div`
  display: flex;
  height: 50px;
  backGround-color: ${Colors.PRIMARY1};
  padding-bottom: 50%;
  padding-top: 50%;
  justify-content: center;
  border-radius: 8px 8px 0px 0px;
  padding: 5px 5px;
  color: #FFF;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 18px;
`;
export const ItemSummary = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 10px 0px 10px;
  position: relative;

  div{
    display: flex;
    flex-direction: column;
    justify-content: left;
    box-sizing: border-box;  
  }

  span{
    position: absolute;
    top: 11px;
    right: 10px;
  }
`;

export const ItemBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #FFF;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 4px 14px;
  height: 500px;
`;

export const CoveragesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  margin: 10px 10px 20px 10px;
  border: 1px solid ${Colors.PRIMARY1};
  border-radius: 5px;
  transition: all 1s ease 2s;  
  `;

export const ItemCoverageHead = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const EditButton = styled.div`
  display: flex;
  align-self: center;s
  align-items: center;
  cursor: pointer;
  border-radius: 8%;
  padding: 5px;
  margin-top: 2px;
  color: #FFF;
  font-weight: 700;
  background-color: ${Colors.PRIMARY1};
  border: 2px solid ${Colors.PRIMARY1};
`;

export const ItemCoverages = styled.div`
  overflow-y: hidden;
  padding: 5px;
  ${({ isCollapse }) => isCollapse && css`max-height: 0px;`}
  transition: all 1s ease 2s; 
`;

export const CoverageItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  border-bottom: 1px solid ${Colors.PRIMARY1};
`;

export const CoverageTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  > i{
    margin-left: 10px;
  }
`;

export const CoverageBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

export const Title = styled.h1`
  font-size: 18px;
  color: #666666;
  font-weight: 700;
  margin-bottom: 2px;
  margin-top: 10px;
`;

export const SubTitle = styled.h2`
  font-size: 17px;
  font-weight: 500;
  margin-top: 2px;
  margin-bottom: 2px;
`;

export const BulletSlide = styled.span`
display: block;  
border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #FFF;
  font-weight: 700;
  opacity: 1;
  background: ${Colors.GREEN};
`;